import { useMutation } from 'react-query';
import { deleteRegisterResultProduct } from 'apis/registerResult';

const useMutationDeleteRegisterResultProduct = () => {
  const { mutateAsync, ...rest } = useMutation(deleteRegisterResultProduct);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationDeleteRegisterResultProduct;
